import React, {useEffect, useState} from 'react';
import { useAdvancedMarkerRef, AdvancedMarker} from '@vis.gl/react-google-maps';


const AdvancedMarkerWithRef = (props) => {
  const {children, onMarkerClick, ...advancedMarkerProps} = props;
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <AdvancedMarker
      onClick={() => {
        if (marker) {
          onMarkerClick(marker);
        }
      }}
      ref={markerRef}
      {...advancedMarkerProps}>
      {children}
    </AdvancedMarker>
  );
};

export default AdvancedMarkerWithRef;